import moment from 'moment';
// import debounce from 'lodash.debounce';

// import store from '@/store';
import axiosInstance from './axios.service';
import { getPointsData } from './points.service';
import { getCurrencySign, normalizeCurrency } from '@/utils/currency';

/* === Get DATA Collection in Merchant === */
export const getDataCollectionInMerchant = async (collectionName) => {
  const url = `/qbeek/merchant-sub/${collectionName}/all`;
  try {
    const snapshot = await axiosInstance.get(url);
    return snapshot
      .map((t) => {
        if (collectionName === 'tasks') {
          t['dateEnd'] = moment(t['dateEnd']).toDate();
          t['dateStart'] = moment(t['dateStart']).toDate();
        }
        return {
          ...t,
        };
      })
      ?.filter((it) => !it?.disabled);
  } catch (error) {
    console.log(`getDataCollectionInMerchant:${collectionName}:fnFirebase.js ===>>> `, error);
  }
};
export const getDataCollectionInMerchantOneItem = async (collectionName, id) => {
  try {
    const target = {};
    const url = `/qbeek/merchant-sub/${collectionName}/read/${id}`;
    const temp = await axiosInstance.get(url);
    if (!temp) return null;
    for (const key in temp) {
      if (
        (Object.prototype.hasOwnProperty.call(temp[key], 'start') || Object.prototype.hasOwnProperty.call(temp[key], 'end'))
      ) {
        if (Object.prototype.hasOwnProperty.call(temp[key], 'start')) {
          target[key]['start'] = temp[key]['start']?.toDate();
        }
        if (Object.prototype.hasOwnProperty.call(temp[key], 'end')) {
          target[key]['end'] = temp[key]['end']?.toDate();
        }
      } else if (key === 'time') {
        if (Object.prototype.hasOwnProperty.call(temp[key], 'start')) {
          target[key]['start'] = temp[key]['start']?.toDate();
        }
        if (Object.prototype.hasOwnProperty.call(temp[key], 'end')) {
          target[key]['end'] = temp[key]['end']?.toDate();
        }
      } else if (key === 'birthday') {
        target[key] = moment(temp[key]).toDate();
      } else if (key === 'dateSent') {
        target[key] = moment(temp[key]).toDate();
      } else if (key === 'dateStart' || key === 'dateEnd') {
        target[key] = moment(temp[key]).toDate();
      } else {
        target[key] = temp[key];
      }
    }
    return target;
  } catch (error) {
    console.log(`getDataCollectionInMerchantOneItem:${collectionName}:${id}: => `, error);
  }
};

export async function saveDataCollectionInMerchant(target, collectionName, docId) {
  if (!docId) {
    const url = `/qbeek/merchant-sub/${collectionName}/create`;
    try {
      const response = await axiosInstance.post(url, target);
      return response;
    } catch (error) {
      console.error('saveDataCollectionInMerchant', error.message);
    }
  } else {
    const url = `/qbeek/merchant-sub/${collectionName}/update/${docId}`;
    try {
      const response = await axiosInstance.post(url, target);
      return response;
    } catch (error) {
      console.error('saveDataCollectionInMerchant', error.message);
    }
  }
}

export const updateDataCollectionInMerchant = async (target, collectionName) => {
  const url = `/qbeek/merchant-sub/${collectionName}/update/${target.id}`;
  try {
    const response = await axiosInstance.post(url, target);
    return response;
  } catch (error) {
    console.error('updateDataCollectionInMerchant', error.message);
  }
};

export const updateDataFieldCollectionInMerchant = async (target, collectionName) => {
  const url = `/qbeek/merchant-sub/${collectionName}/update/${target.id}`;
  try {
    const response = await axiosInstance.post(url, target);
    return response;
  } catch (error) {
    console.error('updateDataCollectionInMerchant', error.message);
  }
};

export const deleteDataCollectionInMerchant = async (collectionName, id) => {
  const url = `/qbeek/merchant-sub/${collectionName}/delete/${id}`;
  try {
    const response = await axiosInstance.delete(url);
    return response;
  } catch (error) {
    console.error('deleteDataCollectionInMerchant ==> ', error.message);
  }
};
export const disabledDataCollectionInMerchant = async (id, collectionName) => {
  const url = `/qbeek/merchant-sub/${collectionName}/update/${id}`;

  try {
    const response = await axiosInstance.post(url, { disabled: true });
    return response;
  } catch (error) {
    console.error('deleteDataCollectionInMerchant ==> ', error.message);
  }
};
export const updateDateSubscriptionInMerchants = async () => {
  try {
    const currentDate = moment();
    const futureDate = currentDate.add(1, 'month').subtract(1, 'day').toDate();
    const url = `/operator/merchant/update`;
    await axiosInstance.post(url, {
      endOfSubscription: futureDate,
    });
  } catch (error) {
    console.error('Error fetching collection:', error.message);
  }
};
export const updateStatusSubscriptionInMerchants = async (id = '', status) => {
  const url = `/operator/merchant/update`;
  try {
    await axiosInstance.post(url, {
      statusOfSubscription: status,
    });
    return { success: true };
  } catch (error) {
    console.error('Error fetching collection:', error.message);
  }
};

const currencyUpdateRequests = new Map();

function getCurrencyUpdateKey(currencyValue) {
  const normalizedCurrency = normalizeCurrency(currencyValue);
  if (!normalizedCurrency || typeof normalizedCurrency !== 'object') {
    return String(normalizedCurrency || '');
  }

  return [
    getCurrencySign(normalizedCurrency),
    normalizedCurrency.currencyCode || '',
    normalizedCurrency.currencyName || '',
    normalizedCurrency.currencyNumCode || '',
  ].join('|');
}

export async function getMerchantCurrencySign(target) {
  try {
    const { default: store } = await import('@/store');
    const currencySign = normalizeCurrency(await store.dispatch('merchantCurrency/fetchCurrency'));

    if (getCurrencySign(currencySign)) {
      if (target?.value !== undefined) {
        target.value = currencySign;
      }
      return currencySign;
    }

    return null;
  } catch (error) {
    console.log('"getMerchantCurrencySign: => ", error);');
    console.log(error);

    return { error };
  }
}
export async function updateMerchantCurrencySign(name) {
  const url = `/operator/merchant/update`;
  const normalizedCurrency = normalizeCurrency(name) || name;
  const requestKey = getCurrencyUpdateKey(normalizedCurrency);

  if (currencyUpdateRequests.has(requestKey)) {
    return currencyUpdateRequests.get(requestKey);
  }

  const request = (async () => {
    try {
      const response = await axiosInstance.post(url, {
        currencySign: normalizedCurrency,
      });
      const { default: store } = await import('@/store');
      store.dispatch('merchantCurrency/setCurrency', normalizedCurrency);
      return response;
    } catch (error) {
      console.log(error);
    } finally {
      currencyUpdateRequests.delete(requestKey);
    }
  })();

  currencyUpdateRequests.set(requestKey, request);
  return request;
}

export const checkNameUniq = async (slugName) => {
  const url = `/operator/merchant/slug-name-is-uniq`;
  try {
    const response = await axiosInstance.post(url, { slugName });

    // API returns true if unique, false if not unique
    // We need to return the actual boolean value from the response
    const result = response === true || response === false ? response : false;

    return result;
  } catch (error) {
    console.error('Error checking name uniqueness:', error);
    return false; // Return false on error to be safe
  }
};

export async function getMerchantSlugName() {
  const url = `/operator/merchant/info`;

  try {
    // Loaded with the merchant on login and kept in sync by set_merchantSlugName, so skip the network when present.
    const { default: store } = await import('@/store');
    if (store.getters.merchantSlugName) return store.getters.merchantSlugName;

    const response = await axiosInstance.get(url);
    return response?.merchantSlugName;
  } catch (error) {
    console.log(error);
  }
}
export async function updateMerchantSlugName(name) {
  try {
    const url = `/operator/merchant/update`;
    const response = await axiosInstance.post(url, { merchantSlugName: name });
    return response;
  } catch (error) {
    console.log(error);
    return false;
  }
}

/* Merchant */
export async function getMerchant() {
  const url = `/operator/merchant/info`;
  try {
    const response = await axiosInstance.get(url);
    return response;
  } catch (error) {
    console.log('Error fetching collection:getMerchant', error);
    return;
  }
}
export async function getMerchantOne() {
  const url = `/operator/merchant/info`;
  try {
    const response = await axiosInstance.get(url);
    return response;
  } catch (error) {
    console.log('Error fetching collection:getMerchantOne', error);
    if ([401, 423].includes(error?.response?.status)) {
      throw error;
    }
  }
}
/* MerchantId */
export async function getMerchantId() {
  try {
    const { merchantId } = await getMerchant();
    return merchantId;
  } catch (error) {
    console.log('Error fetching collection:getMerchantId', error);
  }
}

/* ===Staff=== */

/* Get Staff */
export async function getMerchantStaff() {
  try {
    const { staff } = await getMerchant();
    return staff;
  } catch (error) {
    console.log('Error fetching collection:getMerchantStaff', error);
  }
}
/* Add Staff */
export async function saveMerchantEmployee(employee) {
  const url = `/operator/merchant/update`;
  const urlRead = `/operator/merchant/info`;
  try {
    const merchant = await axiosInstance.get(urlRead);
    if (!merchant?.staff) {
      merchant.staff = [];
    }
    const response = await axiosInstance.post(url, {
       
      staff: [...merchant?.staff, employee],
    });
    console.log('    успешно сохранен!');
    return response;
  } catch (error) {
    console.log('Error fetching collection:saveMerchantEmployee', error);
  }
  //   console.log("Сотрудник успешно сохранен!");
}
export async function checkIfDomainAlreadyExists(target, subdomain) {
  try {
    const pointsBySubdomain = (await getPointsData())?.filter((point) => point.subdomain === subdomain);

    if (pointsBySubdomain.length) {
      target.value = true;
      return true;
    }
    target.value = false;
    return false;
  } catch (error) {
    console.log('Error fetching collection:checkIfDomainAlreadyExists', error);
  }
}
